var DateSelectorYear = (function (_classes, _eventHandler, _dsEventHandler) {
    var templateName = 'date-picker-years';
    var $el = $('<div role="yearSelector" class="date-selector-table date-selector-table__content">');

    var years = [];
    var yearPages = 10;
    var yearsRows = 4;
    var yearsColumn = 4;
    var currentPage = 1;

    var currentYear;

    var yearsCells = yearsRows * yearsColumn;

    var _fillYears = function(maxYear) {
        var currentYear = maxYear || new Date().getFullYear();
        for (var p = 0; p < yearPages; p++) {
            var cells = [];
            for (var c = 0; c < yearsCells; c++) {
                cells[c] = currentYear--;
            }
            years[p] = cells.reverse();
        }
    };

    var _changeYear = function (year) {
        if (year !== currentYear) {
            currentYear = year;
            $el.find('.' + _classes.selectedCell).removeClass(_classes.selectedCell);
            $el.find('@yearCell[data-value="' + currentYear + '"]').addClass(_classes.selectedCell);
        }
    }

    var _subscribe = function () {
        $el.find('@yearCell').on('click', function () {
            var year = $(this).data('value');
            _changeYear(year);
            _eventHandler.trigger('changeYear', currentYear);
        });

        _dsEventHandler.onDisplay(function (e, display) {
            $el.toggleClass(_classes.hidden, display !== 'years');
        });
    };

    _eventHandler.on('changeYear', function (e, year) {
        _changeYear(year);
    });

    return {
        init: function (page, maxYear, pageNum) {
            _fillYears(maxYear);
            if (pageNum != undefined && !page) {
                currentPage = pageNum;
                page = years.slice(currentPage, currentPage + 1);
            } else {
                page = page || years.slice(currentPage, currentPage + 1);
            }
            $el.html($.tmpl(templateName, page));
            currentYear && $el.find('@yearCell[data-value="' + currentYear + '"]').addClass(_classes.selectedCell);
            _subscribe();
        },
        appendTo: function ($container) {
            $container.append($el);
        },
        setPage: function (pageNumber) {
            var p = years.slice(pageNumber, pageNumber + 1);
            if (p.length) {
                currentPage = pageNumber;
                this.init(p);
            }
            return currentPage;
        },
        setYear: function (value) {
            var _page = currentPage;
            _.each(years, function (page, index) {
                _.each(page, function (y) {
                    if (y === value) {
                        _page = index;
                    }
                });
            });
            if (_page !== currentPage) {
                this.setPage(_page);
            }
            _changeYear(value);

            return value;
        },
        onChange: function (func) {
            _eventHandler.on('changeYear', func);
        }
    }
});